// resources/js/Components/item/ItemSummary.jsx
import React from 'react';
import { Box, Typography, Chip, Tooltip, Stack } from '@mui/material';

const ItemSummary = ({ item, allTags }) => {
    if (!item) return null;

    const {
        name,
        group,
        model,
        link,
        nvr_vendor,
        anonymize,
        blur,
        down,
        video_alarm,
        show_motion,
        export_interval,
        skipframe,
        only_anonymize,
        fps_preview,
        status,
        tags_tracked = [],
        tags_fixed = [],
        tags = [],
        tags_anonymize =[],
        export_labels,
        serverStatus,
    } = item;

    const getTagById = (id) =>
        allTags.find((tag) => tag.id.toString() === id.toString())?.name || id;

    const trackedNames = tags_tracked.map(getTagById);
    const clasaNames = tags.map((i)=>i.name);
    const fixedNames = tags_fixed.map(getTagById);
    const anonymizeNames = tags_anonymize.map(getTagById);
    const statusUnknown = status == 'archive';
    const nvrVendorLabel = typeof nvr_vendor === 'string' && nvr_vendor.trim() !== ''
        ? nvr_vendor.trim()
        : null;

    return (
        <Box p={2}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
                Group: {group} · Model: {model}
            </Typography>
            <Typography variant="body2" gutterBottom>
                Stream URL{nvrVendorLabel ? ` (${nvrVendorLabel})` : ''}: <Typography component="span" color="text.secondary">{link}</Typography>
            </Typography>

            <Typography variant="body2" sx={{ mt: 2 }}>
                This item is <strong>{anonymize ? 'set to anonymize' : 'not anonymizing'}</strong> and
                <strong> {only_anonymize ? 'only anonymizes without processing' : 'includes full processing'}</strong>.{" "}<br />
                Video alarms are <strong>{video_alarm ? 'enabled' : 'disabled'}</strong>.<br />
                Motion display is <strong>{show_motion ? 'on' : 'off'}</strong>, and{" "}
                the stream is currently <strong>{serverStatus=='down' ? 'marked as down' : (statusUnknown?'stoped':'up')}</strong>.{" "}<br />
                {export_labels?(<> Export interval is set to <strong>{export_interval} seconds</strong>, and it{" "}
                {skipframe ? 'skips frames for performance' : 'processes all frames'} with{" "}
                a preview at <strong>{fps_preview} fps</strong>.</>):""}
            </Typography>

            <Box mt={2}>
                <Stack direction="row" spacing={2}>
                    <Tooltip title={clasaNames.join(', ') || '-'}>
                        <Chip size="small" label={`Clase: ${tags.length}`} />
                    </Tooltip> <Tooltip title={trackedNames.join(', ') || '-'}>
                        <Chip size="small" label={`Clase tracked: ${tags_tracked.length}`} />
                    </Tooltip>
                    <Tooltip title={fixedNames.join(', ') || '-'}>
                        <Chip size="small" label={`Clase fixed: ${tags_fixed.length}`} />
                    </Tooltip>
                    {anonymize ?(<Tooltip title={anonymizeNames.join(', ') || '-'}>
                        <Chip size="small" label={`Anonymize clases: ${tags_anonymize.length}`} />
                    </Tooltip>):""}
                </Stack>
            </Box>
        </Box>
    );
};

export default ItemSummary;
